module.exports = __webpack_public_path__ + "img/12_24.1cb26a63.png";